const Row = ({ children, className = '', ...props }) => {
  return (
    <div className={`grid grid-cols-12 gap-4 ${className}`} {...props}>
      {children && !Array.isArray(children) ? <Col xs={12}>{children}</Col> : children}
    </div>
  );
};

const Col = ({ xs = 12, sm, md, lg, xl, children, className = '', ...props }) => {
  // Generate classes for each breakpoint
  const getColClass = (size, value) => {
    if (!value) return '';
    return `col-span-${value}`;
  };

  return (
    <div
      className={`
          ${xs ? `sm:col-span-${xs}` : ''}
          ${sm ? `md:col-span-${sm}` : ''}
          ${md ? `lg:col-span-${md}` : ''}
          ${lg ? `xl:col-span-${lg}` : ''}
          ${xl ? `2xl:col-span-${xl}` : ''}
          ${className}
        `}
      {...props}
    >
      {children}
    </div>
  );
};
export { Row, Col };
